import { FC, useEffect, useRef } from 'react';

interface DirectVideoPlayerProps {
  videoUrl: string;
  onVideoComplete: () => void;
  onProgressUpdate: (progress: number) => void;
}

export const DirectVideoPlayer: FC<DirectVideoPlayerProps> = ({
  videoUrl,
  onVideoComplete,
  onProgressUpdate,
}) => {
  console.log('DirectVideoPlayer - URL recibida:', videoUrl);
  
  const videoRef = useRef<HTMLVideoElement>(null);

  // Asegurarse que la URL tenga el protocolo correcto
  const getFullVideoUrl = (url: string) => {
    if (!url) return '';
    // Si ya tiene el protocolo, devolverla como está
    if (url.startsWith('http')) return url;
    // Si no tiene protocolo, agregar https://
    return `https://${url.replace(/^\/+/, '')}`;
  };

  const fullVideoUrl = getFullVideoUrl(videoUrl);
  console.log('DirectVideoPlayer - URL procesada:', fullVideoUrl);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      const progress = (video.currentTime / video.duration) * 100;
      onProgressUpdate(progress);
    };

    video.addEventListener('timeupdate', handleTimeUpdate);
    return () => video.removeEventListener('timeupdate', handleTimeUpdate);
  }, [onProgressUpdate]);

  if (!videoUrl) {
    return (
      <div className="aspect-video rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center">
        <p className="text-gray-500">Video no disponible</p>
      </div>
    );
  }

  return (
    <div className="aspect-video rounded-xl overflow-hidden shadow-lg">
      <video
        ref={videoRef}
        className="w-full h-full"
        controls
        controlsList="nodownload noplaybackrate"
        disablePictureInPicture
        onEnded={onVideoComplete}
        playsInline
        preload="metadata"
        src={fullVideoUrl}
        onError={(e) => {
          console.error('Error loading video:', {
            error: e,
            videoError: videoRef.current?.error,
            url: fullVideoUrl,
            originalUrl: videoUrl
          });
        }}
      />
    </div>
  );
};